import { HeaderWithNextButton } from "@components";
import { SpecPreparationForm } from "./components";

import { useSpecPreparation } from "@hooks/procurements/procurement/useSpecPreparation";

export interface SpecPreparationProps {
  id: any; //!!!
  setSearchParams?: Function;
  changeActiveTab: (arg: number) => void;
  setIsSuccessModalOpen: (arg: boolean) => void;
  setIsErrorModalOpen: (arg: boolean) => void;
}

const SpecPreparation = ({
  id,
  changeActiveTab,
  setIsSuccessModalOpen,
  setIsErrorModalOpen,
}: SpecPreparationProps) => {
  const { getSingleData, setGetDataAfterUpdate } = useSpecPreparation(id);
  return (
    <div className="p-10">
      <HeaderWithNextButton
        title="PROCUREMENT_CREATE.TABS.SPEC_PREPARATION"
        action={() => changeActiveTab(2)}
      />
      <SpecPreparationForm
        id={id}
        changeActiveTab={changeActiveTab}
        setIsSuccessModalOpen={setIsSuccessModalOpen}
        setIsErrorModalOpen={setIsErrorModalOpen}
        specPreparation={getSingleData}
        setGetDataAfterUpdate={setGetDataAfterUpdate}
      />
    </div>
  );
};

export default SpecPreparation;
